import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface OpportunityUsageData {
  current_usage: number;
  limit: number | 'Unlimited';
  percentage_used: number;
  is_at_limit: boolean;
}

interface OpportunityUsageResponse {
  opportunity_id: number;
  subscription_tier: string;
  usage: {
    opportunity_photos: OpportunityUsageData;
    opportunity_documents: OpportunityUsageData;
  };
}

export const useOpportunityUsage = (opportunityId: string | number) => {
  const { data, isLoading, error, refetch } = useQuery<OpportunityUsageResponse>({
    queryKey: ['opportunity-usage', opportunityId],
    queryFn: async () => {
      const response = await api.get<OpportunityUsageResponse>(`/api/usage/opportunity/${opportunityId}/`);
      return response.data;
    },
    enabled: !!opportunityId,
    refetchInterval: 60000, // Refresh every minute
    staleTime: 30000, // Consider data stale after 30 seconds
  });

  return {
    photoUsage: data?.usage?.opportunity_photos,
    docUsage: data?.usage?.opportunity_documents,
    isLoading,
    error,
    refetch,
    subscriptionTier: data?.subscription_tier,
  };
};